module.exports = __webpack_public_path__ + "img/movie1.db22756f.png";